import { Component, Input } from "@angular/core";
import { getNgValueAccessorProvider } from "../../../../../util/form/value-accessor-export-functions";
import { BaseControlValueAccessor } from "../../../../../util/form/BaseControlValueAccessor";
import { SharedComponentsModule } from "../../../module/shared-components.module";
import {
  FundPerformanceFormGroup,
} from "../../../../fund-performance/component/fund-performances/modal/modal-fund-performance-update/fp-form-controls-service/fp-form-pojo";

@Component({
  selector: 'app-carry-combined-inputs',
  templateUrl: './carry-combined-inputs.component.html',
  styleUrls: ['./carry-combined-inputs.component.scss'],
  standalone: true,
  providers: [
    ...getNgValueAccessorProvider(CarryCombinedInputsComponent),
  ],
  imports: [
    SharedComponentsModule,
  ],
})
export class CarryCombinedInputsComponent extends BaseControlValueAccessor<boolean> {
  @Input({ required: true }) formGroup: FundPerformanceFormGroup;
}
